var _style, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageDefaultFood(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E7E9F7;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#C5CBEB;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 500,
    height: 500
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M353.9,101.3c-11.6-0.4-27.6,4.3-40.7,16.8c-13.4,12.8-23.1,33.1-23.1,62.8c0,27.6,4.3,45.5,10.4,57.9 c4.7,9.6,10.4,15.6,14.4,19.5v115.8c0,13.6,11,24.7,24.7,24.7s24.7-11,24.7-24.7V111.9v-10.3L353.9,101.3z M311.4,180.9 c0-24.7,7.9-39.2,16.5-47.4c4.9-4.7,10.2-7.6,15-9.2v249.9c0,1.9-1.5,3.4-3.4,3.4c-1.9,0-3.4-1.5-3.4-3.4V253.8v-4.4l-3.1-3.1 c-0.8-0.8-1.5-1.5-2.3-2.2c-3.9-3.7-7.7-7.4-11.2-14.6C315.4,220.8,311.4,206.3,311.4,180.9z M157,111.9c0-5.9-4.8-10.6-10.6-10.6 s-10.6,4.8-10.6,10.6v82.8c0,14.7,7.1,28.4,19.1,36.9c6.8,4.8,10.6,12.9,10,21.2l-7.3,105.6c-1.5,21.9,15.9,40.5,37.8,40.5 c22,0,39.3-18.6,37.8-40.5l-7.4-106.9c-0.5-7.8,2.8-15.4,8.9-20.2c10.7-8.5,17-21.5,17-35.2v-84c0-5.9-4.8-10.6-10.6-10.6 c-5.9,0-10.6,4.8-10.6,10.6v84c0,7.2-3.3,14.1-9,18.6c-11.6,9.2-17.9,23.5-16.9,38.3l7.4,106.9c0.7,9.6-7,17.8-16.6,17.8 c-9.6,0-17.3-8.2-16.6-17.8l7.3-105.6c1.1-15.7-6.1-30.9-19-40c-6.3-4.5-10.1-11.8-10.1-19.5V111.9z M178.3,103.9c4.4,0,8,3.6,8,8 v63.7c0,4.4-3.6,8-8,8s-8-3.6-8-8v-63.7C170.3,107.5,173.9,103.9,178.3,103.9z M210.2,103.9c4.4,0,8,3.6,8,8v63.7c0,4.4-3.6,8-8,8 s-8-3.6-8-8v-63.7C202.2,107.5,205.8,103.9,210.2,103.9z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageDefaultFood);
export default __webpack_public_path__ + "static/media/image-default-food.0fcf7d1a.svg";
export { ForwardRef as ReactComponent };